// extracted by mini-css-extract-plugin
export default {"primary-button":"PrimaryButton_primary-button__0wmyJ","span":"PrimaryButton_span__Ul46J","button-icon":"PrimaryButton_button-icon__vIj4H"};